export const SET_IS_AUTHENTICATED = 'set_is_authenticated';
export const SET_NAME = 'set_name';
